import { Route } from "@angular/router";
import { BasketComponent } from "./basket.component";
import { BasketResolver } from "./shared/basket.resolver";

export const BasketRouting: Route = {
    path: 'basket',
    component: BasketComponent,
    outlet: 'basket',
    resolve:{
        basket: BasketResolver
    },
    data: {
        breadcrumb: "Panier"
    }
}
